export const ORDER_CREATE_REQUEST="ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS="ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAILED="ORDER_CREATE_FAILED";
export const ORDER_CREATE_RESET="ORDER_CREATE_RESET";

export const ORDER_PAY_REQUEST="ORDER_PAY_REQUEST";
export const ORDER_PAY_SUCCESS="ORDER_PAY_SUCCESS";
export const ORDER_PAY_FAILED="ORDER_PAY_FAILED";
export const ORDER_PAY_RESET="ORDER_PAY_RESET";

export const ORDER_DETAILS_REQUEST="ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS="ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL="ORDER_DETAILS_FAIL";

export const ORDER_MINE_LIST_REQUEST="ORDER_MINE_LIST_REQUEST"
export const ORDER_MINE_LIST_SUCCESS="ORDER_MINE_LIST_SUCCESS"
export const ORDER_MINE_LIST_FAIL="ORDER_MINE_LIST_FAIL"